// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1A-94","vLegacy":"SelectSecondary_vLegacy__3IhxJ","error":"SelectSecondary_error__2aDLy","disabled":"SelectSecondary_disabled__3SYOl"};